import React, { useEffect, useState } from 'react';
import InputForm from '../../InputT';
import SearInputM from '../../SearchModal';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../Types/ParamsPicklist';
import { Box, TextField, Tooltip, Typography } from '@mui/material';
import { Button, Form, Input, Select, Space } from 'antd';
import Table, { ColumnsType } from 'antd/es/table';
import { Add, Delete } from '@mui/icons-material';
import Datas from "../../../Data/Data.json"
import { Crypter } from '../../../Functions/Security/Crypter';
import { useAuthHeader } from '../../../Services/Auth/sessionAuth';
import axios from 'axios';
import SweetAlert from "sweetalert2"
import DataType2 from '../../../Types/DataTablePiclist';
import { FormProvider, useForm } from 'react-hook-form';
import LoginForm from '../../LoginForm';
import Data from '../../../Data/Data.json'

interface DataType {
  key: string;
  CODUTI: string;
  CODAGE: string;
  CODGROUP: string;
  LIBAGE?: string;
  LIBGRP?: string;
}
interface SelectData{
  value: string;
  label: string;
}


let searchTypAdr:Params={CodeAgence:'',Table: "TYPADR",Colonne1:"CODTYPE",Colonne2:"LIBELL1",Colagence:'001',Choix:22} 
let searchAgence:Params={CodeAgence:'',Table: "AGENCE",Colonne1:"CODAGE",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchGroup:Params={CodeAgence:'',Table: "GROUPUSER",Colonne1:"CODGROUP",Colonne2:"LIBELLE",Colagence:'101',Choix:22}


function Tab3(props:{form?: any}){
  const [agences,SetAgences]=React.useState<SelectData[]>([]);
  const [profils,SetProfils]=React.useState<SelectData[]>([]);
  const [Donnee,setDonnee]=React.useState<DataType[]>([]);
  const [pageIsLoad, setPageIsLoad] = useState(true);
  const [loadingAgence, setLoadaingAgence] = useState(true);
  const [loadingProfil, setLoadaingProfil] = useState(true);
  const [codage, setCodage] = useState<string>();
  const [codgroup, setCodgroup] = useState<string>();

  // USER TOKEN
  const authHeader = useAuthHeader()

  // if(localStorage.length == 0){
  //   setDonnee([])
  // }


  // Libellé d'un code à partir des listes chargées (ou du libellé stocké)
  const libOf = (list: SelectData[], code?: string, fallback?: string) => {
    if (!code) return '';
    if (fallback) return fallback;
    const opt = list.find(o => o.value === code);
    if (!opt) return code;
    // label de picklist = "code - libellé" -> on garde la partie libellé
    const idx = String(opt.label).indexOf(' - ');
    return idx >= 0 ? String(opt.label).substring(idx + 3) : String(opt.label);
  };

  const columns: ColumnsType<DataType> = [
  {
    title: 'Agence',
    dataIndex: 'CODAGE',
    key: 'codeAgence',
    render: (_, r) => <span><b>{r.CODAGE}</b>{libOf(agences, r.CODAGE, r.LIBAGE) ? ` — ${libOf(agences, r.CODAGE, r.LIBAGE)}` : ''}</span>,
  },
  {
    title: 'Profil',
    dataIndex: 'CODGROUP',
    key: 'codeProfil',
    render: (_, r) => <span><b>{r.CODGROUP}</b>{libOf(profils, r.CODGROUP, r.LIBGRP) ? ` — ${libOf(profils, r.CODGROUP, r.LIBGRP)}` : ''}</span>,
  },
  {
    title: 'Action',
    key: 'action',
    width: 90,
    align: 'center',
    render: (_, record) => (
      <Space size="middle">
        <Tooltip title='Retirer de la liste'>
        <Button danger size='small' icon={<Delete fontSize='small' />} onClick={()=>{
          const newRows : DataType[] = Donnee.filter(d => !(d.CODAGE == record.CODAGE && d.CODGROUP == record.CODGROUP));
          setDonnee(newRows)
          localStorage.setItem(Data.LocalVariable.userDistanceHabillitation, Crypter.encrypt(JSON.stringify(newRows)))
        }} />
        </Tooltip>
      </Space>
    ),
  },
];

  const handleChangeAgence = (value: string) => {
    setCodage(value);
  };
  const handleChangeGroupe = (value: string) => {
    setCodgroup(value);
  };

  if(pageIsLoad){
      //alert(Data.ApiUrl.authentification)
      loadAgence()
      loadProfil()
      setPageIsLoad(false)
  }

  function loadAgence(){
    setLoadaingAgence(true)
    
    const datat: SelectData[] = [];
    //alert("aaa")
      var param = {CodeAgence:'',Table: "AGENCE",Colonne1:"CODAGE",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
      //console.log(Crypter.encrypt(JSON.stringify(data)))
      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.AnySearch,
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherSearch': Crypter.encrypt(JSON.stringify(param))
        }
      };
      axios(config)
      .then((response)=>{
      //alert('ok')
      if(response.data){
        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
        
        
        if(res.StatutCode == 200){
          let datas = res.Result.Table;
          
          if(datas.length===0){
            //console.log("aucun élément ");
            SetAgences(datat)
            }
            else{
              datas.map((data : any)=>{
                //console.log(JSON.stringify(data))
                datat.push({
                  value: data[Object.keys(data)[1]],
                  label: data[Object.keys(data)[1]] +' - '+ data[Object.keys(data)[0]],
                });
                SetAgences(datat);  
              })
            }
        }
      }
      setLoadaingAgence(false)
      //setLoading(false);
      
    }).catch((error)=>{
      setLoadaingAgence(false)
      console.log(error)
      //setLoading(false);
      SweetAlert.fire({title: "Error", text : error})
    })
  }


  function loadProfil(){
    setLoadaingProfil(true)
    
    const datat: SelectData[] = [];
    //alert("aaa")
      var param = {CodeAgence:'',Table: "GROUPUSER",Colonne1:"CODGROUP",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
      //console.log(Crypter.encrypt(JSON.stringify(data)))
      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.AnySearch,
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherSearch': Crypter.encrypt(JSON.stringify(param))
        }
      };
      axios(config)
      .then((response)=>{
      //alert('ok')
      if(response.data){
        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
        
        
        if(res.StatutCode == 200){
          let datas = res.Result.Table;
          
          if(datas.length===0){
            SetProfils(datat)
            }
            else{
              datas.map((data : any)=>{
                //console.log(JSON.stringify(data))
                datat.push({
                  value: data[Object.keys(data)[1]],
                  label: data[Object.keys(data)[1]] +' - '+ data[Object.keys(data)[0]],
                });
                SetProfils(datat);  
              })
            }
        }
      }
      setLoadaingProfil(false)
      //setLoading(false);
      
    }).catch((error)=>{
      setLoadaingProfil(false)
      console.log(error)
      //setLoading(false);
      SweetAlert.fire({title: "Error", text : error})
    })
  }

  function add(){
    if (codage && codgroup) {
      const newData: DataType = {
        key: `${codage}-${codgroup}`,
        CODUTI : '', 
        CODAGE: codage,
        CODGROUP: codgroup,
        LIBAGE: libOf(agences, codage),
        LIBGRP: libOf(profils, codgroup)
      };

      if (Donnee.find((d)=>d.CODGROUP == codgroup && d.CODAGE == codage)) {
        SweetAlert.fire({title: "Attention", text : "Cette configuration existe déjà", icon : "warning"})
      }
      else if (Donnee.find((d)=>d.CODGROUP != codgroup && d.CODAGE == codage)) {
        SweetAlert.fire({title: "Attention", text : "Un Utilisateur ne peux pas avoir plusieurs profils dans une agence", icon : "warning"})
      }
      else{
        setDonnee([...Donnee, newData]);
        localStorage.setItem(Data.LocalVariable.userDistanceHabillitation, Crypter.encrypt(JSON.stringify([...Donnee, newData])))
        //console.log(Donnee)
      }
    }
    else{
      SweetAlert.fire({title: "Attention", text : "Veillez sélectionner les éléments indiqués", icon : "warning"})
    }
  }





  function loadData(){
    try{
      let data = JSON.parse(Crypter.decrypt(localStorage.getItem(Datas.LocalVariable.userDistanceHabillitation)+'')+"")
      //alert(JSON.stringify(data))
      setDonnee(data)
      console.log(data)
    }catch(error){
      console.log(error)
    }
  }
  
  // setTimeout(() => {
  //   if (Donnee.length == 0) {
  //     loadData()
  //   }
  //   try{
  //     let reset = localStorage.getItem(Datas.LocalVariable.reset)
  //     if (reset == "1") {
  //       setDonnee([])
  //       localStorage.clear()
  //     }
  //   }
  //   catch(error){ }
  // }, 0.1);

  useEffect(()=>{
    if (Donnee.length == 0) {
      loadData()
    }
    try{
      let reset = localStorage.getItem(Datas.LocalVariable.reset)
      if (reset == "1") {
        setDonnee([])
        localStorage.clear()
      }
    }
    catch(error){ }
  })

  return(
    <div className='tabItem'>
      <div>
        <Box fontStyle="inherit">
          <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>
            {/* Sélection agence + profil */}
            <fieldset className="bordure1" style={{ marginBottom: 8, padding: '8px 12px' }}>
              <legend style={{ fontSize: '14px', padding: '0 8px', color: '#116599' }}>Nouvelle habilitation</legend>
              <Box display="grid" gridTemplateColumns="1fr 1fr 110px" gap={2} alignItems="end">
                <Box>
                  <label style={{ fontWeight: 'bold', color: '#116599' }}>Agence autorisée</label>
                  <Select
                    loading={loadingAgence}
                    disabled={loadingAgence}
                    onChange={handleChangeAgence}
                    value={codage}
                    id='codage'
                    size='large'
                    placeholder="Choisir une agence"
                    style={{ width: '100%' }}
                    options={agences}
                    showSearch optionFilterProp="label"
                  />
                </Box>
                <Box>
                  <label style={{ fontWeight: 'bold', color: '#116599' }}>Profil autorisé</label>
                  <Select
                    loading={loadingProfil}
                    disabled={loadingProfil}
                    onChange={handleChangeGroupe}
                    value={codgroup}
                    id='codgroup'
                    size='large'
                    placeholder="Choisir un profil"
                    style={{ width: '100%' }}
                    options={profils}
                    showSearch optionFilterProp="label"
                  />
                </Box>
                <Button type="primary" size='large' icon={<Add fontSize='small' />} onClick={add} block>
                  Ajouter
                </Button>
              </Box>
            </fieldset>

            {/* Panier des habilitations */}
            <fieldset className="bordure1" style={{ padding: '8px 12px' }}>
              <legend style={{ fontSize: '14px', padding: '0 8px', color: '#116599' }}>Panier — habilitations ({Donnee.length})</legend>
              <Table columns={columns} pagination={false} dataSource={Donnee}
                rowKey={(r) => `${r.CODAGE}-${r.CODGROUP}`}
                size='small' scroll={{ y: 320, x: 500 }}
                locale={{ emptyText: 'Aucune habilitation — ajoutez une agence et un profil' }} />
            </fieldset>
          </Box>
        </Box>
      </div>
    </div>
);
}

export default Tab3;